<template>
    <!-- Header -->
    <header id="page-header">
        <!-- Header Content -->
        <div class="content-header">
            <!-- Left Section -->
            <div>
                <!-- Toggle Sidebar -->
                <!-- Layout API, functionality initialized in Template._uiApiLayout()-->
                <button
                        type="button"
                        class="btn btn-dual mr-1"
                        data-toggle="layout"
                        data-action="sidebar_toggle"
                >
                    <i class="fa fa-fw fa-bars"></i>
                </button>
                <!-- project dropdown -->
                <div class="dropdown d-inline-block" v-if="projects.hasOwnProperty('data')">
                    <button
                            type="button"
                            class="btn btn-dual"
                            id="page-header-project-dropdown"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                    >
                        <!-- <i class="fa fa-fw fa-user d-sm-none"></i> -->
                        <i class="material-icons d-sm-none mt-2">
                            code
                        </i>
                        <span class="d-none d-sm-inline-block">{{activeProject.hasOwnProperty('name') ? activeProject.name : 'Select Project'}}</span>
                        <i class="fa fa-fw fa-angle-down ml-1 d-none d-sm-inline-block"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-left p-0">
                        <div v-for="(project, pIdx) in projects.data" :key="pIdx">
                            <a v-if="activeProject.id !== project.id" @click="switchProject(project)" href="javascript:void"
                               class="dropdown-item">
                                <i class="far fa-fw fa-folder-open mr-1"></i>
                                {{project.name}}
                            </a>
                        </div>
                    </div>
                </div>

            </div>
            <!-- END Left Section -->

            <!-- Right Section -->
            <div>
                <!-- User Dropdown -->
                <div
                        class="dropdown d-inline-block"
                        v-if="user"
                >
                    <button
                            type="button"
                            class="btn btn-dual"
                            id="page-header-user-dropdown"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                    >
                        <i class="fa fa-fw fa-user d-sm-none"></i>
                        <span class="d-none d-sm-inline-block">{{user.name}}</span>
                        <i class="fa fa-fw fa-angle-down ml-1 d-none d-sm-inline-block"></i>
                    </button>
                    <div
                            class="dropdown-menu dropdown-menu-right p-0"
                            aria-labelledby="page-header-user-dropdown"
                    >
                        <div class="bg-primary-darker rounded-top font-w600 text-white text-center p-3">
                            User Options
                        </div>
                        <div class="p-2">
                            <router-link
                                    :to="{name: 'user.profile'}"
                                    class="dropdown-item"
                            >
                                <i class="far fa-fw fa-user mr-1"></i> Profile
                            </router-link>

                            <!-- Toggle Side Overlay -->
                            <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
                            <a
                                    class="dropdown-item"
                                    href="javascript:void(0)"
                                    data-toggle="layout"
                                    data-action="side_overlay_toggle"
                            >
                                <i class="far fa-fw fa-building mr-1"></i> Settings
                            </a>
                            <!-- END Side Overlay -->

                            <div
                                    role="separator"
                                    class="dropdown-divider"
                            ></div>
                            <a
                                    href=""
                                    class="dropdown-item"
                                    @click.once.prevent="logOutUser"
                            >
                                <i class="far fa-fw fa-arrow-alt-circle-left mr-1"></i> Sign Out
                            </a>
                        </div>
                    </div>
                </div>
                <!-- END User Dropdown -->

                <!-- Toggle Side Overlay -->
                <!-- Layout API, functionality initialized in Template._uiApiLayout() -->
                <button
                        type="button"
                        class="btn btn-dual"
                        @click="openDocsPage"
                >
                    <i class="far fa-fw fa-list-alt"/>
                    Docs
                </button>
                <!-- END Toggle Side Overlay -->
            </div>
            <!-- END Right Section -->
        </div>
        <!-- END Header Content -->
        <!-- Header Loader -->
        <!-- Please check out the Loaders page under Components category to see examples of showing/hiding it -->
        <div
                id="page-header-loader"
                class="overlay-header bg-primary-darker"
        >
            <div class="content-header">
                <div class="w-100 text-center">
                    <i class="fa fa-fw fa-2x fa-sun fa-spin text-white"></i>
                </div>
            </div>
        </div>
        <!-- END Header Loader -->
    </header>
    <!-- END Header -->
</template>

<script>
    // import EventBus from '../../bus/events';
    import {mapGetters} from "vuex";

    export default {
        computed: {
            ...mapGetters({
                projects: "getProjects",
                activeProject: 'getProject',
            })
        },
        mounted() {
            this.getProjects(1)
        },
        methods: {
            logOutUser() {
                this.$store.dispatch("logOut", {
                    endPoint: "logout",
                    user: this.$store.getters.getAuthenticatedUser,
                    options: {}
                });
            },

            getProjects(page = 1) {
                this.$store.dispatch("getProjects", {
                    page,
                    query: ''
                });
            },
            /**
             *
             **/
            switchProject(project) {
                this.$store.commit('setProject', project);
                this.$router.push({
                    name: "project-settings.apps",
                    params: {
                        project: project.id
                    }
                });
            },
            /**
             * Show the the search field
             */
            openDocsPage() {
                window.open("https://docs.emalify.com", "_blank");
            }
        }
    };
</script>
